const RESCUE_LINK_SPECIES_KEY = 'fi-rescue-link-species';

/**
 * Records whether the adopter link named the pet's species (`?type=dog|cat`). Read from the landing
 * url rather than the pdp's, because `useSpeciesUrlParam` writes `?type=dog` onto the pdp whenever it
 * is missing, so by the time the pdp renders every url looks like it carried one.
 *
 * Session storage rather than a url param or router state: the pdp rewrites both, and the answer has
 * to survive a reload of the pdp. Storage can throw (private mode, blocked site data); losing the
 * flag only shows the species chooser, which is the safe side.
 */
export function rememberRescueLinkSpecies(search: string) {
  const type = new URLSearchParams(search).get('type');
  try {
    if (type === 'dog' || type === 'cat') {
      sessionStorage.setItem(RESCUE_LINK_SPECIES_KEY, type);
    } else {
      sessionStorage.removeItem(RESCUE_LINK_SPECIES_KEY);
    }
  } catch {
    // see above: no flag means the chooser shows
  }
}

/** True when the adopter link that opened this session named the species. */
export function rescueLinkNamedSpecies(): boolean {
  try {
    return !!sessionStorage.getItem(RESCUE_LINK_SPECIES_KEY);
  } catch {
    return false;
  }
}

/**
 * Whether the pdp offers the dog/cat chooser. Everyone gets it except an adopter whose link already
 * named the species: older adopter links carry no `?type=`, and without the chooser those adopters
 * could never leave the dog page.
 */
export function showSpeciesSwitcher(rescueVariant: boolean): boolean {
  return !rescueVariant || !rescueLinkNamedSpecies();
}
